<!-- This component now automatically navigates to either the first application or the welcome page -->
<div *ngIf="apService.loadingAllApplications" class="content-block">
  <div class="margin-top">Loading...</div>
</div>
